// 超级管理员
export const superAdmin = [{
    title: '工作台',
    url: '/pages/index/home',
    icon: 'home',
    isShow: true,
    children: []
},
// {
//     title: '消息通知',
//     url: '/pages/index/message',
//     icon: 'luntan',
//     children: [
//         {
//             title: '消息列表',
//             url: '/pages/index/message/list',
//             children: []
//         },
//     ]
// },
{
    title: '文章管理',
    url: '/pages/index/articles',
    icon: 'IDF',
    isShow: true,
    children: [{
        title: '文章列表',
        url: '/pages/index/articles/list',
        isShow: true,
        children: []
    },
    {
        title: '文章分类',
        url: '/pages/index/articles/classify',
        isShow: true,
        children: []
    }
    ]
},
{
    title: '宣传视频管理',
    url: '/pages/index/videoManage',
    icon: 'video',
    isShow: true,
    children: [{
        title: '视频列表',
        url: '/pages/index/videoManage/list',
        isShow: true,
        children: []
    },
    {
        title: '视频分类',
        url: '/pages/index/videoManage/classify',
        isShow: true,
        children: []
    }
    ]
},
{
    title: '新闻管理',
    url: '/pages/index/news',
    icon: 'xinwen',
    isShow: true,
    children: [{
        title: '新闻列表',
        url: '/pages/index/news/list',
        isShow: true,
        children: []
    }]
},
{
    title: '影片管理',
    url: '/pages/index/film',
    icon: 'movie',
    isShow: true,
    children: [{
        title: '影片列表',
        url: '/pages/index/film/list',
        isShow: true,
        children: []
    },
    {
        title: '分类列表',
        url: '/pages/index/film/classify',
        isShow: true,
        children: []
    },
        // {
        //     title: '奖项管理',
        //     url: '/pages/index/film/prize',
        //     children: []
        // }
    ]
},
{
    title: '展映排期',
    group_title: '展映信息',
    url: '/pages/index/record',
    icon: 'yingpian',
    isShow: true,
    children: [{
        title: '展映影片列表',
        url: '/pages/index/record/list',
        isShow: true,
        children: []
    },
        // {
        //     title: '展映主题分类',
        //     url: '/pages/index/record/classify',
        //     isShow: true,
        //     children: []
        // },
    ]
},
{
    title: 'IDF论坛',
    url: '/pages/index/forum',
    icon: 'luntan',
    isShow: true,
    children: [{
        title: '论坛列表',
        url: '/pages/index/forum/list',
        isShow: true,
        children: []
    }]
},
{
    title: '报名管理',
    url: '/pages/index/enroll',
    icon: 'baoming',
    isShow: true,
    children: [{
        title: '会员列表',
        group_title: "会员信息",
        url: '/pages/index/enroll/member_list',
        isShow: true,
        children: []
    },
    {
        title: '报名列表',
        url: '/pages/index/enroll/entry/list',
        isShow: true,
        children: []
    },
    {
        title: '志愿者列表',
        group_title: "志愿者管理",
        url: '/pages/index/enroll/volunteer/listVolunt',
        isShow: true,
        children: []
    },
    {
        title: '嘉宾/媒体列表',
        group_title: "嘉宾/媒体",
        url: '/pages/index/enroll/media/listMedia',
        isShow: true,
        children: []
    },
    {
        title: '用户上传列表',
        url: '/pages/index/enroll/upload_list',
        isShow: true,
        children: []
    },
        // {
        //     title: '作品须知',
        //     url: '/pages/index/enroll/notice',
        //     children: []
        // }
    ]
},
{
    title: '轮播图管理',
    url: '/pages/index/img',
    icon: 'tubiaozhizuomoban-',
    isShow: true,
    children: [{
        title: '轮播图列表',
        url: '/pages/index/img/list',
        isShow: true,
        children: []
    },
    {
        title: '分类列表',
        url: '/pages/index/img/classify',
        isShow: true,
        children: []
    }
    ]
},
{
    title: '评委管理',
    group_title: "评委列表",
    url: '/pages/index/rater',
    icon: 'pingwei',
    isShow: true,
    children: [{
        title: '评委列表',
        url: '/pages/index/rater/list',
        isShow: true,
        children: []
    },
    {
        title: '分类列表',
        url: '/pages/index/rater/classify',
        isShow: true,
        children: []
    }
    ]
},
{
    title: '系统设置',
    url: '/pages/index/setting',
    icon: 'setting',
    isShow: true,
    children: [{
        title: '站点信息',
        url: '/pages/index/setting/siteInfo',
        isShow: true,
        children: []
    },
    {
        title: '年份设置',
        url: '/pages/index/setting/year',
        isShow: true,
        children: []
    },
    {
        title: '语言设置',
        url: '/pages/index/setting/lang',
        isShow: true,
        children: []
    },
    {
        title: '地点设置',
        url: '/pages/index/setting/address',
        isShow: true,
        children: []
    },
    {
        title: '申报组别设置',
        url: '/pages/index/setting/applicationGroup',
        isShow: true,
        children: []
    },
    {
        title: '奖项管理',
        url: '/pages/index/setting/prize',
        isShow: true,
        children: []
    },
    {
        title: '消息通知',
        url: '/pages/index/setting/notify',
        isShow: true,
        children: []
    },
    {
        title: '用户管理',
        url: '/pages/index/setting/user',
        isShow: true,
        children: []
    },
    {
        title: '角色管理',
        url: '/pages/index/setting/authority',
        isShow: true,
        children: []
    },
        // {
        //     title: '数据备份',
        //     url: '/pages/index/setting/backup',
        //     children: []
        // }
        // {
        //     title: '系统日志',
        //     url: '/pages/index/setting/log',
        //     children: []
        // }
    ]
}
];
export const zyzAdmin = [{
    title: '工作台',
    url: '/pages/index/home',
    icon: 'home',
    children: []
},
{
    title: '报名管理',
    url: '/pages/index/enroll',
    icon: 'baoming',
    children: [

        {
            title: '志愿者列表',
            url: '/pages/index/enroll/volunteer/listVolunt',
            children: []
        }
    ]
},

];

export const memberAdmin = [];

export default {
    superAdmin, // 管理员
    zyzAdmin, //志愿者
    memberAdmin // 会员
};


// WEBPACK FOOTER //
// ./src/router/menu/index.js